{
  "hasGlobal": true,
  "participations": [
    {
      "competitionId": "comp-global-01",
      "competitionName": "Liga Global de Mánagers",
      "competitionGroupId": "5dd77e79-80eb-0d1a-567a-42912a3989f8",
      "competitionUnitId": "5dd77e79-80eb-0d1a-567a-42912a3989f8",
      "groupId": "5dd77e79-80eb-0d1a-567a-42912a3989f8",
      "unitId": "5dd77e79-80eb-0d1a-567a-42912a3989f8",
      "seasonId": "00000000-0000-4000-8000-000000000101",
      "seasonName": "Temporada 2026/27",
      "divisionId": "div-10",
      "divisionName": "10ª División",
      "divisionLevel": 10,
      "groupName": "Tenth Division Group 0001 Cycle 1",
      "cycleNumber": 1,
      "currentMatchday": 8,
      "totalMatchdays": 38,
      "teamCount": 6,
      "teamCapacity": 6,
      "status": "ACTIVE",
      "active": true,
      "isCurrent": true,
      "clubId": "7efa5b1e-93e2-5b1f-b29c-14f6d1c9dfee",
      "club": {
        "id": "7efa5b1e-93e2-5b1f-b29c-14f6d1c9dfee",
        "name": "Test FC",
        "code": "D10-G0001-C02"
      }
    }
  ],
  "global": {
    "competitionId": "comp-global-01",
    "name": "Liga Global de Mánagers",
    "seasonName": "Temporada 2026/27",
    "divisionId": "div-10",
    "divisionName": "10ª División",
    "divisionLevel": 10,
    "groupName": "Tenth Division Group 0001 Cycle 1",
    "competitionGroupId": "5dd77e79-80eb-0d1a-567a-42912a3989f8",
    "competitionUnitId": "5dd77e79-80eb-0d1a-567a-42912a3989f8",
    "groupId": "5dd77e79-80eb-0d1a-567a-42912a3989f8",
    "unitId": "5dd77e79-80eb-0d1a-567a-42912a3989f8",
    "seasonId": "00000000-0000-4000-8000-000000000101",
    "status": "JOINED",
    "currentMatchday": 8,
    "totalMatchdays": 38,
    "teamCount": 6,
    "teamCapacity": 6,
    "clubId": "7efa5b1e-93e2-5b1f-b29c-14f6d1c9dfee",
    "club": {
      "id": "7efa5b1e-93e2-5b1f-b29c-14f6d1c9dfee",
      "name": "Test FC",
      "code": "D10-G0001-C02"
    }
  },
  "privateLeagues": [
    {
      "id": "league-private-vip",
      "name": "Superliga de Amigos VIP",
      "code": "VIP-2026",
      "description": "Liga privada de 10 participantes entre amigos.",
      "totalClubs": 10,
      "userClubName": "Test FC",
      "divisionName": "División Amigos",
      "status": "ACTIVE",
      "currentMatchdayNumber": 1,
      "totalMatchdays": 18
    }
  ],
  "privateLeaguesEnabled": true
}
